import { FieldError } from "react-hook-form"

/* 
  !!! Not intended for direct use !!!
  This is used inside useAnalyticsStore.
  A direct use will not update the data layer and probably lead to future wrong data sent
*/
export function trackAnalyticsEvent(data: Record<string, string | number>) {
  if (typeof window === "undefined") return

  try {
    console.dir(data) // TODO RIMUOVERE QUANDO SI RITOCCHERA'
    window.adobeDataLayer?.push(data)
  } catch (error) {
    console.error("Error on adobeDataLayer.push", error)
  }
}

export function getDifferences(
  oldState: Record<string, FieldError>,
  newState: Record<string, FieldError>,
) {
  const diffObj: Record<string, FieldError> = {}
  for (const key in newState) {
    if (!(key in oldState) || oldState[key].message !== newState[key].message) {
      diffObj[key] = newState[key]
    }
  }

  return diffObj
}
